import script from "./GitHistoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GitHistoryPage.vue?vue&type=script&setup=true&lang=ts"

import "./GitHistoryPage.vue?vue&type=style&index=0&id=7b2e4237&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2e4237"]])

export default __exports__